module.exports = __webpack_public_path__ + "static/media/spinner.c14b2f87.gif";